"use client";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useGetLoggedInUser } from "@/hooks/use-get-logged-in-user";
import { cn } from "@/lib/utils";
import { useNavMenuHidden } from "@/stores/navmenu.atoms";
import type { Route } from "next";
import Link from "next/link";
import { usePathname } from "next/navigation";
import type * as React from "react";
import { useSidebar } from "../../../stores/sidebar.atoms";

export function NavigationDesktop() {
    const { user: userProfile } = useGetLoggedInUser();

    const [, setSidebar] = useSidebar();

    const navbarHidden = useNavMenuHidden();

    return (
        <div className="flex justify-end">
            <nav className="pointer-events-none absolute inset-0 flex w-full items-center justify-center gap-8">
                {!navbarHidden && (
                    <div className="pointer-events-auto flex gap-8">
                        <NavItem href="/onboard">Onboard</NavItem>
                        <NavItem href="/plans">Plans</NavItem>
                        <NavItem href="/blog">Blog</NavItem>
                    </div>
                )}
            </nav>
            {userProfile === undefined && (
                <div className="flex items-center">
                    <Skeleton className="h-6 w-20" />
                </div>
            )}
            {userProfile === null && (
                <>
                    <Button
                        variant="outline"
                        onClick={() => {
                            setSidebar({ open: true, type: "login" });
                        }}
                    >
                        Log In
                    </Button>
                    <Button
                        className="ml-2"
                        onClick={() => {
                            setSidebar({ open: true, type: "signup" });
                        }}
                    >
                        Sign Up
                    </Button>
                </>
            )}
            {userProfile && (
                <Button asChild size="sm">
                    <Link href="/dashboard">Go to Dashboard</Link>
                </Button>
            )}
        </div>
    );
}

function NavItem({ href, children }: { href: Route; children: React.ReactNode }) {
    const pathname = usePathname();
    const isActive = pathname?.includes(href);

    return (
        <Link
            className={cn(
                "font-medium text-muted-foreground text-sm transition-all hover:text-foreground active:text-white",
                {
                    "font-semibold text-foreground": isActive,
                },
            )}
            href={href}
        >
            {children}
        </Link>
    );
}
